<template>
  <b-modal id="modal_process_background" hide-footer size="xl">
    <template #modal-title>
      Procesos agendados - {{ title }}
    </template>
    <b-collapse visible>
      <div class="d-flex justify-content-between align-items-center mb-3">
        <p>
          Por favor tener en cuenta que los procesos generados solo estarán disponibles por 2 horas
        </p>
        <b-button variant="primary" @click="_loadProccessBackground">
          <i class="fa fa-refresh mr-1"></i>
          Actualizar información
        </b-button>
      </div>
      <!-- historico -->
      <b-table responsive striped hover :items="backgroundProcess" :fields="columns" bordered thead-class="table-active"
               show-empty empty-text="No hay resultados para mostrar.">
        <!-- estado -->
        <template v-slot:cell(estado_procesamiento)="data">
          <b-badge v-if="data.item.estado_procesamiento == 'PROCESANDO'" variant="warning"
                   v-text="data.item.estado_procesamiento"/>
          <b-badge v-else-if="data.item.estado_procesamiento == 'TERMINADO'" variant="success"
                   v-text="data.item.estado_procesamiento"/>
          <b-badge v-else variant="secondary"
                   v-text="data.item.estado_procesamiento ? data.item.estado_procesamiento : 'PENDIENTE'"/>
        </template>
        <template v-slot:cell(total)="data">
          <p class="text-right m-0"> {{ data.item.json.total_products ? data.item.json.total_products : 0 }}</p>
        </template>
        <template v-slot:cell(year_import)="data">
          <p class="text-right m-0"><i
              class="text-muted">{{ data.item.json.year_import ? data.item.json.year_import : `No aplica` }}</i></p>
        </template>
        <template v-slot:cell(errores)="data">
          {{
            data.item.errores ? data.item.errores :
                !data.item.estado_procesamiento || data.item.estado_procesamiento == 'PROCESANDO'
                    ? ''
                    : 'Sin errores'
          }}
        </template>
        <template v-slot:cell(downloadable)="data">
          <b-button
              v-if="data.item.downloadable"
              variant="success"
              @click="downloadFile(data.item)"
          >
            <i class="fa fa-download icon"></i>
            Descargar
          </b-button>
        </template>
      </b-table>
    </b-collapse>
    <br/>
    <div class="d-flex justify-content-end align-items-center mt-4">
      <b-button @click="closeModal">
        <i class="fa fa-close fa-lg"></i>
        <span class="ml-1"> Cerrar</span>
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import {mapActions, mapState} from "vuex";
export default {
  name: "ModalShowProcessBackground",
  props: ['columns', 'type', 'company_id', 'title'],
  data() {
    return {
    }
  },
  computed: {
    ...mapState("background_processes", ['backgroundProcess']),
  },
  methods: {
    ...mapActions("background_processes", ['loadProccessBackground', 'downloadReport']),
    closeModal() {
      this.$bvModal.hide('modal_process_background');
    },
    async _loadProccessBackground() {
      await this.loadProccessBackground({type: this.type, company_id: this.company_id});
    },
    async downloadFile(item) {
      await this.downloadReport(item)
    },
  },
}
</script>
<style scoped>
.downloadableButton {
  width: 70px !important;
  max-width: 100px !important;
  min-width: 70px !important;
}
</style>
